module.exports = __webpack_public_path__ + "images/12-03@2x_ddb97e38.png";